<template>
  <Modal
    v-if="!!addPasswordModal"
    confirmText="Spara lösenord"
    cancelText="Avbryt"
    :disabled="!isValidPassword"
    :headingLarge="true"
    :hideFooterDivider="true"
    :headingDivider="true"
    :loading="isAdding"
    loadingText="Sparar lösenord"
    secondaryButtonStyle="tertiery"
    v-on:confirm="onSavePassword(password)"
    v-on:cancel="
      provider = null;
      addPasswordModal = false;
    "
    header="Lägg till ett säkert lösenord"
    size="md"
    :addSpace="false"
  >
    <p class="text-b1 mb-2">
      Välj ett lösenord som du sedan kan använda för att logga in på Mina sidor.
    </p>

    <Form @submit="onSavePassword(this.password)" :validation-schema="schema" v-slot="{ meta }">

      <label class="text-b2 font-bold !hidden" for="password">Lösenord</label>
      <div class="relative mt-8">
        <Field
          v-slot="{ field, meta }"
          v-model="password"
          name="password"
          type="text"
          id="password"
          label="Lösenord"
          class="relative"
        >
          <Input
            label="Lösenord"
            v-bind="field"
            :floatingLabel="true"
            placeholder="Lösenord"
            @input="event => checkText(event.target.value)"
            :type="showPassword ? 'text' : 'password'"
          />
          <button
            type="button"
            @click="togglePassword"
            class="absolute text-[#007893] font-normal text-[13px] leading-4 font-proxima-nova top-[-22px] right-[8px] flex gap-2 items-center"
          >
            <template v-if="!showPassword">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="12" viewBox="0 0 18 12" fill="none">
                <path d="M9.00029 9C9.93779 9 10.7347 8.67188 11.3909 8.01562C12.0472 7.35938 12.3753 6.5625 12.3753 5.625C12.3753 4.6875 12.0472 3.89062 11.3909 3.23438C10.7347 2.57812 9.93779 2.25 9.00029 2.25C8.06279 2.25 7.26592 2.57812 6.60967 3.23438C5.95342 3.89062 5.62529 4.6875 5.62529 5.625C5.62529 6.5625 5.95342 7.35938 6.60967 8.01562C7.26592 8.67188 8.06279 9 9.00029 9ZM9.00029 7.65C8.43779 7.65 7.95967 7.45313 7.56592 7.05938C7.17217 6.66563 6.97529 6.1875 6.97529 5.625C6.97529 5.0625 7.17217 4.58437 7.56592 4.19063C7.95967 3.79688 8.43779 3.6 9.00029 3.6C9.56279 3.6 10.0409 3.79688 10.4347 4.19063C10.8284 4.58437 11.0253 5.0625 11.0253 5.625C11.0253 6.1875 10.8284 6.66563 10.4347 7.05938C10.0409 7.45313 9.56279 7.65 9.00029 7.65ZM9.00029 11.25C7.32529 11.25 5.79717 10.8 4.41592 9.9C3.03467 9 1.94404 7.8125 1.14404 6.3375C1.08154 6.225 1.03467 6.10938 1.00342 5.99063C0.972168 5.87188 0.956543 5.75 0.956543 5.625C0.956543 5.5 0.972168 5.37813 1.00342 5.25938C1.03467 5.14062 1.08154 5.025 1.14404 4.9125C1.94404 3.4375 3.03467 2.25 4.41592 1.35C5.79717 0.45 7.32529 0 9.00029 0C10.6753 0 12.2034 0.45 13.5847 1.35C14.9659 2.25 16.0565 3.4375 16.8565 4.9125C16.919 5.025 16.9659 5.14062 16.9972 5.25938C17.0284 5.37813 17.044 5.5 17.044 5.625C17.044 5.75 17.0284 5.87188 16.9972 5.99063C16.9659 6.10938 16.919 6.225 16.8565 6.3375C16.0565 7.8125 14.9659 9 13.5847 9.9C12.2034 10.8 10.6753 11.25 9.00029 11.25Z" fill="#007893"/>
              </svg> Visa text
            </template>
            <template v-else>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <mask id="mask0_3193_4685" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                  <rect width="18" height="18" fill="#D9D9D9"/>
                </mask>
                <g mask="url(#mask0_3193_4685)">
                  <path d="M14.3248 16.4252L11.6998 13.8377C11.2623 13.9752 10.8186 14.0783 10.3686 14.1471C9.91856 14.2158 9.46231 14.2502 8.99981 14.2502C7.3248 14.2502 5.79355 13.8002 4.40605 12.9002C3.01855 12.0002 1.93105 10.8127 1.14355 9.3377C1.08105 9.2252 1.03418 9.10957 1.00293 8.99082C0.97168 8.87207 0.956055 8.7502 0.956055 8.6252C0.956055 8.5002 0.97168 8.37832 1.00293 8.25957C1.03418 8.14082 1.08105 8.0252 1.14355 7.9127C1.41855 7.4252 1.7123 6.9502 2.0248 6.4877C2.3373 6.0252 2.6998 5.6127 3.1123 5.2502L1.55605 3.6752C1.41855 3.5377 1.3498 3.36582 1.3498 3.15957C1.3498 2.95332 1.4248 2.7752 1.5748 2.6252C1.7123 2.4877 1.8873 2.41895 2.0998 2.41895C2.3123 2.41895 2.4873 2.4877 2.6248 2.6252L15.3748 15.3752C15.5123 15.5127 15.5842 15.6846 15.5904 15.8908C15.5967 16.0971 15.5248 16.2752 15.3748 16.4252C15.2373 16.5627 15.0623 16.6314 14.8498 16.6314C14.6373 16.6314 14.4623 16.5627 14.3248 16.4252ZM8.99981 12.0002C9.13731 12.0002 9.26855 11.9939 9.39355 11.9814C9.51855 11.9689 9.64355 11.9439 9.76855 11.9064L5.71855 7.85645C5.68105 7.98145 5.65605 8.10645 5.64355 8.23145C5.63105 8.35645 5.6248 8.4877 5.6248 8.6252C5.6248 9.5627 5.95293 10.3596 6.60918 11.0158C7.26543 11.6721 8.0623 12.0002 8.99981 12.0002ZM8.99981 3.0002C10.6748 3.0002 12.2092 3.45332 13.6029 4.35957C14.9967 5.26582 16.0873 6.45645 16.8748 7.93145C16.9373 8.03145 16.9842 8.14082 17.0154 8.25957C17.0467 8.37832 17.0623 8.5002 17.0623 8.6252C17.0623 8.7502 17.0498 8.87207 17.0248 8.99082C16.9998 9.10957 16.9561 9.21895 16.8936 9.31894C16.6561 9.78145 16.3904 10.2189 16.0967 10.6314C15.8029 11.0439 15.4748 11.4314 15.1123 11.7939C14.9373 11.9689 14.7311 12.0502 14.4936 12.0377C14.2561 12.0252 14.0498 11.9314 13.8748 11.7564L12.3748 10.2564C12.2873 10.1689 12.2311 10.0658 12.2061 9.94707C12.1811 9.82832 12.1873 9.70645 12.2248 9.58145C12.2748 9.41895 12.3123 9.2627 12.3373 9.1127C12.3623 8.9627 12.3748 8.8002 12.3748 8.6252C12.3748 7.6877 12.0467 6.89082 11.3904 6.23457C10.7342 5.57832 9.93731 5.2502 8.99981 5.2502C8.8248 5.2502 8.6623 5.2627 8.5123 5.2877C8.3623 5.3127 8.20605 5.3502 8.04355 5.4002C7.91855 5.4377 7.79355 5.44395 7.66855 5.41895C7.54355 5.39395 7.4373 5.3377 7.3498 5.2502L6.73105 4.63145C6.49356 4.39395 6.41543 4.11895 6.49668 3.80645C6.57793 3.49395 6.77481 3.29395 7.08731 3.20645C7.3998 3.14395 7.71543 3.09395 8.03418 3.05645C8.35293 3.01895 8.67481 3.0002 8.99981 3.0002ZM10.4811 7.2377C10.6186 7.4002 10.7342 7.57832 10.8279 7.77207C10.9217 7.96582 10.9811 8.16895 11.0061 8.38145C11.0186 8.48145 10.9811 8.5502 10.8936 8.5877C10.8061 8.6252 10.7248 8.60645 10.6498 8.53145L9.1123 6.99395C9.0373 6.91895 9.02168 6.8377 9.06543 6.7502C9.10918 6.6627 9.18106 6.61895 9.28106 6.61895C9.51855 6.64395 9.7373 6.70957 9.93731 6.81582C10.1373 6.92207 10.3186 7.0627 10.4811 7.2377Z" fill="#007893"/>
                </g>
              </svg> Dölj text
            </template>
          </button>

        </Field>
      </div>
    </Form>

    <div class="mb-[-8px]">
      <p class="font-proxima-nova text-[14px] text-[#5E5E5E] mt-2 mb-1 leading-[163%]">Lösenordet måste innehålla</p>

      <div v-for="rule in getPasswordRules()" :key="rule.label" class="flex items-center gap-2">
          <!-- Ikon -->
          <div v-if="rule.valid" class="w-4 h-4 text-green-600 ml-[-2px] mr-[-2px]">
            <!-- checkmark -->
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <rect x="2.33333" y="2.33333" width="11.3333" height="11.3333" rx="5.66667"
                    fill="#47851E" stroke="#47851E" stroke-width="0.666667"/>
              <path d="M10.6668 6L7.00016 9.66667L5.3335 8"
                    stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <div v-else class="w-3 h-3 border border-solid rounded-full bg-gray-300"></div>

          <!-- Text -->
          <span class="text-[13px] text-[#9D9D9C]">{{ rule.label }}</span>
        </div>
    </div>
  </Modal>

  <Modal
    v-if="!!passwordAddedModal"
    confirmText="Stäng"
    :headingLarge="false"
    :hideFooterDivider="false"
    :headingDivider="false"
    v-on:confirm="
      passwordAddedModal = false;
    "
    v-on:cancel="
      passwordAddedModal = false;
    "
    :hasClose="true"
    size="sm"
    :addSpace="false"
  >
    <div class="flex flex-col items-center">
      <div class="w-6 h-6 rounded-full bg-[#E5EEC8] flex items-center justify-center mb-2"><IconCheck /></div>
      <h2 class="text-t5 mb-2">Lösenord tillagt</h2>
      <p class="text-b2 text-center leading-[163%]">
        Nu kan du använda ditt lösenord för att logga in på Mina sidor
      </p>
    </div>
  </Modal>


  <Modal
    v-if="errorMsg"
    confirmText="Okej, jag förstår"
    cancelText=""
    v-on:confirm="errorMsg = null"
    v-on:cancel="
      errorMsg = null
    "
    header="Det gick inte att lägga till inloggningssätt"
    hasClose
    size="sm"
    :headingLarge="true"
    :hideCloseText="true"
  >
    <p>
      {{errorMsg}}
    </p>
  </Modal>

  <Modal
    v-if="showRemoveLoginMethodModal"
    confirmText="Ja, jag är säker"
    cancelText="Nej, avbryt"
    v-on:confirm="removeLoginMethod(provider, () => {
      provider = null;
      showRemoveLoginMethodModal = false;
    })"
    v-on:cancel="
      provider = null;
      showRemoveLoginMethodModal = false;
    "
    header="Är du säker på att du vill ta bort inloggningssättet?"
    hasClose
    size="md"
  >
    <p>
      Om du går vidare så kommer {{provider}} att tas bort som inloggningssätt för dig till
      Mina sidor.
    </p>
  </Modal>

  <Modal
    v-if="errorMsg"
    confirmText="Okej, jag förstår"
    cancelText=""
    v-on:confirm="errorMsg = null"
    v-on:cancel="
      errorMsg = null
    "
    header="Det gick inte att lägga till inloggningssätt"
    hasClose
    size="sm"
    :headingLarge="true"
    :hideCloseText="true"
  >
    <p>
     {{errorMsg}}
    </p>
  </Modal>
  <CardLoaderSmall v-if="loading" class="col-span-full flex-1 flex-col" />
  <box v-else class="col-span-full">
    <h3 class="text-t4 mb-2">Ändra din inloggning</h3>
    <h4 class="text-t6 mb-4">
      Här kan du ta bort eller lägga till olika sätt att logga in på Mina sidor.
    </h4>

    <div v-if="!loading" class="space-y-3">
      <div
        v-for="method in loginMethods"
        :key="method.provider"
        class="align-center flex flex-col md:flex-row items-center space-y-2 md:space-y-0 md:space-x-5"
      >
        <div class="align-center flex flex-row items-center space-x-5 w-full md:w-1/2" >
          <div
            class="align-center flex h-7 min-w-7 w-7 items-center justify-center rounded-full bg-gray-20"
            :class="method.enabledByUser == false ? 'invisible' : ''"
          >
            <IconCheck />
          </div>
          <div class="flex w-full flex-col space-y-2">
            <Button
              disabled="true"
              variant="social"
              :class="method.provider.toLowerCase() == 'apple' ? 'bg-black text-white' : ''"
              :state="method.isRemovable === false ? 'cannot-remove' : ''"
            >
              <template #icon-before>
                <IconBankID class="h-4 w-4" v-if="method.provider.toLowerCase() == 'bankid'" />
                <IconApple class="h-4 w-4" v-else-if="method.provider.toLowerCase() == 'apple'" />
                <IconGoogle class="h-4 w-4" v-else-if="method.provider.toLowerCase() == 'google'" />
                <IconMicrosoft
                  class="h-4 w-4"
                  v-else-if="method.provider.toLowerCase() == 'microsoft'"
                />
                <IconGavleGardarna class="h-4 w-4" v-else />
              </template>
              Logga in med {{ method.displayName }}
            </Button>
          </div>
        </div>

        <div class="w-full flex justify-end md:w-auto">
          <Button
            v-if="method.enabledByUser && method.isRemovable != false"
            variant="danger"
            class="ml-auto"
            @click="
              provider = method.provider;
              showRemoveLoginMethodModal = true;
            "
          >
            Ta bort
            <template #icon-after>
              <IconTrashCan class="h-4 w-4" />
            </template>
          </Button>

          <Button
            v-if="(method.provider !== 'Local' && !method.enabledByUser) || (!method.enabledByUser && method.isAddable && method.provider !== 'Local')"
            variant="secondary"
            @click="addLoginMethod(method.provider)"
          >
            Lägg till
            <template #icon-after><IconPlus /></template>
          </Button>

          <Button
            v-if="method.provider == 'Local' && !method.enabledByUser"
            variant="secondary"
            @click="addPassword()"
          >
            Lägg till
            <template #icon-after><IconPlus /></template>
          </Button>
        </div>
      </div>

    </div>
  </box>
</template>


<script setup>
const schema = {
  password: 'required',
};

</script>



<script>
import Box from '@/components/ui/box';
import Button from '@/components/ui/button';
import { axios } from '@/store/config';
import IconPlus from '@/components/icons/IconPlus';
import IconTrashCan from '@/components/icons/IconTrashCan';
import IconGoogle from '@/components/icons/IconGoogle';
import IconMicrosoft from '@/components/icons/IconMicrosoft';
import IconBankID from '@/components/icons/IconBankID';
import IconGavleGardarna from '@/components/icons/IconGavleGardarna';
import IconApple from '@/components/icons/IconApple';
import IconCheck from '@/components/icons/IconCheck';
import Modal from '@/components/ui/modal';
import CardLoaderSmall from '@/components/loader/CardLoaderSmall';
import { Form, Field, ErrorMessage } from 'vee-validate';
import Input from '@/components/ui/form/input';
import {mapGetters} from "vuex";

export default {
  name: 'LoginMethodsSection',
  components: {
    Input,
    Form,
    Field,
    ErrorMessage,
    Box,
    Button,
    IconPlus,
    IconTrashCan,
    IconGoogle,
    IconMicrosoft,
    IconBankID,
    Modal,
    IconGavleGardarna,
    IconApple,
    IconCheck,
    CardLoaderSmall,
  },
  data() {
    return {
      provider: null,
      loading: true,
      loginMethods: [],
      showRemoveLoginMethodModal: false,
      errorMsg: "",
      addPasswordModal: false,
      passwordAddedModal: false,
      password: "",
      showPassword: false,
      isAdding: false,
      // testAlwaysLoading: true,
    };
  },
  computed: {
    ...mapGetters({
      passwordPolicy: 'rules',
    }),


    isValidPassword() {
      const value = this.password || ""
      const policy = this.passwordPolicy

      // liten bokstav
      if (policy.requireLowercase) {
        const count = typeof policy.requireLowercase === "number" ? policy.requireLowercase : 1
        if ((value.match(/[a-z]/g) || []).length < count) return false
      }

      // stor bokstav
      if (policy.requireUppercase) {
        const count = typeof policy.requireUppercase === "number" ? policy.requireUppercase : 1
        if ((value.match(/[A-Z]/g) || []).length < count) return false
      }

      // siffra
      if (policy.requireDigit) {
        const count = typeof policy.requireDigit === "number" ? policy.requireDigit : 1
        if ((value.match(/[0-9]/g) || []).length < count) return false
      }

      // specialtecken
      if (policy.requireNonAlphanumeric) {
        const count = typeof policy.requireNonAlphanumeric === "number" ? policy.requireNonAlphanumeric : 1
        if ((value.match(/[^a-zA-Z0-9]/g) || []).length < count) return false
      }

      // minsta längd
      if (policy.minLength && value.length < policy.minLength) return false

      // unika tecken
      if (policy.requiredUniqueChars && policy.requiredUniqueChars > 1) {
        if (new Set(value.split("")).size < policy.requiredUniqueChars) return false
      }

      return true
    }

  },
  methods: {
    getPasswordRules() {
      const rules = []
      const policy = this.passwordPolicy
      const pwd = this.password

      if (policy.requireLowercase) {
        const count = typeof policy.requireLowercase === 'number' ? policy.requireLowercase : 1
        rules.push({
          label: count === 1
            ? `${count} liten bokstav`
            : `${count} små bokstäver`,
          valid: (pwd.match(/[a-z]/g) || []).length >= policy.requireLowercase
        })
      }

      if (policy.requireUppercase) {
        const count = typeof policy.requireUppercase === 'number' ? policy.requireUppercase : 1
        rules.push({
          label: count === 1
            ? `${count} stor bokstav`
            : `${count} stora bokstäver`,
          valid: (pwd.match(/[A-Z]/g) || []).length >= policy.requireUppercase
        })
      }

      if (policy.requireDigit) {
        const count = typeof policy.requireDigit === 'number' ? policy.requireDigit : 1
        rules.push({
          label: count === 1
            ? `${count} siffra`
            : `${count} siffror`,
          valid: (pwd.match(/[0-9]/g) || []).length >= policy.requireDigit
        })
      }

      if (policy.requireNonAlphanumeric) {
        const count = typeof policy.requireNonAlphanumeric === 'number' ? policy.requireNonAlphanumeric : 1
        rules.push({
          label: `${count} specialtecken (t.ex. %/#!)`,
          valid: (pwd.match(/[^a-zA-Z0-9]/g) || []).length >= policy.requireNonAlphanumeric
        })
      }

      if (policy.minLength > 0) {
        rules.push({
          label: `Minst ${policy.minLength} tecken`,
          valid: pwd.length >= policy.minLength
        })
      }

      /*if (policy.requiredUniqueChars) {
        const count = typeof policy.requiredUniqueChars === 'number' ? policy.requiredUniqueChars : 1
        rules.push({
          label: `Minst ${count} unika tecken`,
          valid: new Set(pwd.split("")).size >= policy.requiredUniqueChars
        })
      }
*/
      return rules
    },

    togglePassword() {
      this.showPassword = !this.showPassword;
    },

    onSavePassword(password) {
      if (!this.isValidPassword) return false;
      this.errorMsg = null;
      this.isAdding = true;
      axios
        .post('/applicants/password', {
          password
        })
        .then((response) => {
          this.isAdding = false;
          this.addPasswordModal = false;
          this.passwordAddedModal = true;
          this.fetchLoginMethods();

        })
        .catch((err) => {
          this.isAdding = false;
          this.errorMsg = 'Kunde inte lägga till inloggningssätt. Försök igen.';
        });
    },

    addPassword() {
      this.password = "";
      this.addPasswordModal = true;
    },

    fetchLoginMethods() {
      this.loading = true;
      if (!this.testAlwaysLoading) {
        new Promise((resolve) => setTimeout(resolve, 500)).then(() => {
          axios
            .get('/applicants/loginmethods')
            .then((res) => {
              this.loginMethods = res.data;
            })
            .catch((err) => {
              console.error('Fel vid hämtning av inloggningsmetoder:', err);
            })
            .finally(() => {
              this.loading = false;
            });
        });
      }
    },
    addLoginMethod(provider) {
      this.errorMsg = null;
      axios
        .post('/applicants/loginmethods', {
          provider,
          returnUrl: window.location.href,
        })
        .then((response) => {
          window.location.href = response.data.url;
        })
        .catch((err) => {
          this.errorMsg = 'Kunde inte lägga till inloggningssätt. Försök igen.';
        });
    },
    removeLoginMethod(provider, callback) {
      this.errorMsg = null;
      if (!provider) return;
      axios
        .put('/applicants/loginmethods', {provider})
        .then(() => {
          this.fetchLoginMethods();
        })
        .then(() => {
          callback();
        })
        .catch((err) => {
          this.errorMsg = 'Kunde inte ta bort inloggningssättet. Försök igen.';
        });
    },
  },


  mounted() {
    if (!this.testAlwaysLoading) {
      setTimeout(() => {
        this.fetchLoginMethods();
      }, 500);
    } else {
      this.fetchLoginMethods();
    }

    const errorStatus = this.$route.query.errorStatus;
    if (errorStatus) {
      if (errorStatus === 'AddLoginError') {
        this.errorMsg = "Kunde inte lägga till inloggningssättet, försök igen senare.";
      } else if (errorStatus === 'AddLoginAlreadyAssociatedError') {
        this.errorMsg = "Inloggningssättet är redan kopplat till ett annat konto.";
      }
    }
  }
}
</script>

<style scoped lang="scss">
  input {

    &::placeholder {
      color: #757575;
    }

    &:not(:focus).is-danger {
      border-color: #D32F2F !important;
    }

    &:disabled {
      background-color: $lightgray;
    }

    &[data-invalid="true"] {
      border: 1px solid #D32F2F !important;
    }

    &[data-valid="true"] + span {

      &:after {
        position: absolute;
        right: 16px;
        top: 24px;
        content: url(https://abgmypagescode.blob.core.windows.net/public/drop/static/images/icon-check.svg);
      }
    }

  }
</style>
